<div class="breading-crumb">

  <ng-container *ngFor="let item of selectedItem?.breadcrumb; last as isLast">
    <span>{{item}}</span><span *ngIf="!isLast" class="mg-r-5 mg-l-5"><i class="fas fa-chevron-right"></i></span>
  </ng-container>

</div>
